import { render, staticRenderFns } from "./CourseUser.vue?vue&type=template&id=6b9439b2&scoped=true&"
import script from "./CourseUser.vue?vue&type=script&lang=js&"
export * from "./CourseUser.vue?vue&type=script&lang=js&"
import style0 from "./CourseUser.vue?vue&type=style&index=0&id=6b9439b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9439b2",
  null
  
)

export default component.exports